import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  text: 'Alleno tre gruppi con livelli molto diversi e la domenica sera finiva sempre con me davanti al computer a costruire schede. Con RHYTHMIC GYM PRO™ apro il modulo di pianificazione, scelgo esercizi e progressioni per ogni gruppo e in venti minuti ho la settimana pronta. In palestra arrivo lucida e organizzata.',
  author: 'Silvia Marchetti',
  role: 'Allenatrice di ginnastica ritmica, 37 anni',
  location: 'Bologna, Emilia-Romagna'
}, {
  text: 'La biblioteca di esercizi e progressioni è la parte che uso ogni giorno. Avevo anni di appunti sparsi tra quaderni e video: ora ho tutto suddiviso per obiettivo e livello. Le mie atlete percepiscono che ogni allenamento ha una direzione precisa e i progressi tecnici si vedono.',
  author: 'Chiara Ferretti',
  role: 'Tecnico agonistica, 42 anni',
  location: 'Torino, Piemonte'
}, {
  text: 'Il sistema di preparazione alle competizioni mi ha cambiato la stagione. Le settimane pre-gara sono pianificate, le simulazioni sono strutturate e le checklist mi evitano di dimenticare dettagli sotto pressione. Sono arrivata alle gare regionali molto più serena delle scorse stagioni.',
  author: 'Martina De Luca',
  role: 'Allenatrice squadra agonistica, 31 anni',
  location: 'Napoli, Campania'
}, {
  text: 'Gestisco una piccola società e la documentazione era il mio incubo: schede atleta, registri, valutazioni. Il toolkit dell’allenatore mi ha dato modelli professionali già pronti da personalizzare. Le famiglie ricevono report chiari e la percezione del nostro lavoro è cresciuta tantissimo.',
  author: 'Federica Rinaldi',
  role: 'Responsabile tecnica di società, 45 anni',
  location: 'Padova, Veneto'
}, {
  text: 'Il bonus sulle coreografie e quello sulla correzione tecnica valgono da soli il prezzo. Ho strutture di composizione già impostate e protocolli precisi per correggere gli errori più frequenti. Passo molto meno tempo a preparare e molto più tempo a osservare e correggere le mie ginnaste.',
  author: 'Alessia Conti',
  role: 'Allenatrice gruppi promozionali e agonistici, 29 anni',
  location: 'Roma, Lazio'
}];
export function Testimonials() {
  return <section className="py-4 px-4 sm:px-6 bg-brand-blushLight border-y-2 border-brand-blush" data-id="element-135" data-mp="1oj5erriw09s6">
      <div className="text-center mb-3" data-id="element-136" data-mp="1jkkext7jrs49">
        <h2 className="font-display text-3xl sm:text-5xl tracking-wide text-brand-plum leading-none uppercase" data-id="element-137" data-mp="1ejek9pubtus3">
          Cosa dicono gli allenatori
        </h2>
        <p className="text-[11px] font-heading font-bold text-brand-pink uppercase tracking-widest" data-id="element-138" data-mp="14tbjh3gyrcj7">
          Recensioni verificate
        </p>
      </div>
      <div className="flex flex-col gap-2" data-id="element-139" data-mp="10t1bxmdiwe28">
        {testimonials.map(testimonial => <article key={testimonial.author} className="bg-white border border-brand-blush p-3 rounded-md shadow-sm" data-id="element-140" data-mp="vrc1a7u7q2eo">
            <div className="flex gap-0.5 mb-1" data-id="element-141" data-mp="qu2d0vik7wsf">
              {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="w-3.5 h-3.5 fill-brand-gold text-brand-gold" data-id="element-142" data-mp="32ge4r9sddi0a" />)}
            </div>
            <p className="text-brand-slate font-medium italic text-xs sm:text-sm leading-snug" data-id="element-143" data-mp="37htomyit9ih3">
              &quot;{testimonial.text}&quot;
            </p>
            <div className="border-t border-brand-blush pt-1.5 mt-1.5 flex gap-2 items-center" data-id="element-144" data-mp="3gfds8e45bquv">
              <div className="w-8 h-8 rounded-full bg-brand-blush text-brand-plum font-bold text-sm flex items-center justify-center shrink-0" data-id="element-145" data-mp="2jrpj2lm2b8ng">
                {testimonial.author.charAt(0)}
              </div>
              <div data-id="element-146" data-mp="2spjgjzvkc8c7">
                <p className="font-bold text-brand-plum text-xs" data-id="element-147" data-mp="2sozwodmcr9vj">— {testimonial.author}</p>
                <p className="text-[10px] text-brand-slate font-bold uppercase tracking-wide leading-tight" data-id="element-148" data-mp="2xj4756utu01d">
                  {testimonial.role} — {testimonial.location}
                </p>
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}